import { useQuery } from '@apollo/client';

import { useCurrentUser } from 'javascripts/hooks';
import { ADMIN, hasRoleAccess } from 'helpers/roles';
import { isPast, parseISO } from 'date-fns';
import {
  COMPANY_BILLING_QUERY,
  COMPANY_STATUS_QUERY,
} from '../../invitations/gql/CompanyBilling.graphql';

function getIsInTrial(trialEnd) {
  if (trialEnd) {
    const isoTrialEnd = parseISO(trialEnd);
    const pastTrial = isPast(isoTrialEnd);
    return !pastTrial;
  }
  return false;
}

const useRoleSafeBillingQuery = () => {
  const currentUser = useCurrentUser();
  const isAdmin = hasRoleAccess(currentUser, [ADMIN]);

  const query = isAdmin ? COMPANY_BILLING_QUERY : COMPANY_STATUS_QUERY;

  const { loading, data, startPolling, stopPolling } = useQuery(query);
  const companyInfo = data?.viewer?.company ?? {};
  const billingInfo = data?.viewer?.billing ?? {};

  const sampleEligible = billingInfo?.sampleEligible ?? false;

  const openSeats = billingInfo?.subscription?.emptySeats ?? 0;
  const hasSeatsAvailable = openSeats > 0;

  const identifier = companyInfo?.plan?.identifier;
  const active = companyInfo?.active;

  const trialEnd = companyInfo?.trialEnd;
  const isInTrial = getIsInTrial(trialEnd);

  return {
    active,
    data,
    hasSeatsAvailable,
    identifier,
    isAdmin,
    isInTrial,
    loading,
    openSeats,
    sampleEligible,
    startPolling,
    stopPolling,
  };
};

export default useRoleSafeBillingQuery;
